import { Check, Circle, TriangleAlert } from "lucide-react";

export interface ReadinessCheck {
  label: string;
  detail?: string;
  state: "met" | "unmet" | "later";
}

function Marker({ state }: { state: ReadinessCheck["state"] }) {
  if (state === "met") {
    return (
      <Check
        className="mt-0.5 h-4 w-4 shrink-0 text-success"
        strokeWidth={2}
        aria-hidden="true"
      />
    );
  }

  const Glyph = state === "unmet" ? TriangleAlert : Circle;
  return (
    <Glyph
      className={`mt-0.5 h-4 w-4 shrink-0 ${
        state === "unmet" ? "text-warning" : "text-foreground/70"
      }`}
      strokeWidth={3}
      aria-hidden="true"
    />
  );
}

export function ResourceReadiness({ checks }: { checks: ReadinessCheck[] }) {
  return (
    <div className="overflow-hidden rounded-lg bg-base">
      <ul className="list-none">
        {checks.map((check) => (
          <li
            key={check.label}
            className="flex items-start gap-2.5 border-t border-muted/50 px-3 py-2.5 text-sm first:border-t-0"
          >
            <Marker state={check.state} />
            <span className="min-w-0">
              <span
                className={check.state === "unmet" ? "" : "text-foreground/70"}
              >
                {check.label}
              </span>
              {check.detail && (
                <span className="mt-0.5 block text-xs text-foreground/70">
                  {check.detail}
                </span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
